import type MailListViewState from 'mini-mail-list-store/lib/store/schema/MailListViewState';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import type SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import {
    SEARCH_NO_RESULTS_RENDERED,
    SEARCH_RESULTS_ERROR,
    SEARCH_RESULTS_RENDERED,
} from 'mini-workflow-tracking/lib/constants/SearchWorkflowConstants';

/**
 * Utility function which triggers search signals for workflow.
 * @param tableView TableView of the current query
 * @param loadState Current loadstate of the table
 */
export function triggerSearchSignals(tableView: TableView, loadState: MailListViewState) {
    // If this is triggered during loadmore scenario in which case page number will > 0
    // Don't log the datapoint unneccesarily
    if ((tableView.tableQuery as SearchTableQuery)?.pageContext?.pageNumber !== 0) {
        return;
    }

    switch (loadState) {
        case 0:
            signalWorkflowEvent(SEARCH_RESULTS_RENDERED);
            break;
        case 2:
            signalWorkflowEvent(SEARCH_NO_RESULTS_RENDERED);
            break;
        case 4:
            signalWorkflowEvent(SEARCH_RESULTS_ERROR, null, null, {
                error: new Error('Unable to fetch search results'),
            });
            break;
        default:
            break;
    }
}
